<template>
  <div v-if="observations.length > 0" class="informations-container">
    <InformationRow v-for="obs in observations" :key="obs.id" :obs="obs" @load="load"/>
  </div>
</template>

<script>
import InformationRow from './information/row.vue'
export default {
  components: {
    InformationRow
  },
  data () {
    return {
      observations: []
    }
  },
  methods: {
    load () {
      this.loading = true
      this.$store.dispatch('getInformations').then((observations) => {
        this.loading = false
        this.observations = observations
      }).catch(() => {
        this.loading = false
        this.$notify({
          title: 'Erreur',
          message: 'Impossible de charger les notifications',
          type: 'error'
        })
      })
    }
  },
  mounted () {
    this.load()
  }
}
</script>

<style lang='scss' scoped>
  .informations-container {
    margin-top: 15px;
  }
</style>
